import productType from "./productType";

//product
export const successFetchedProduct =(data)=>({
type: productType.SUCCESS_FETCHIED_PRODUCT,
payload: data
 })
export const failureFetchedProduct =(data)=>({
type: productType.FAILURE_FETCHED_PRODUCT,
payload: data
 })

 //change search params
 export const changePageParams =(data)=>({
    type: productType.CHANGE_GRADE_PARAMS,
    errorMessage: data
     })

